import { makeAutoObservable } from "mobx"

export class LoginPageStore {
  email: string
  confirmationCode: string
  isCodeInputVisible: boolean
  pressedButton: "signup" | "signin" | null

  constructor() {
    this.email = ""
    this.confirmationCode = ""
    this.isCodeInputVisible = false
    this.pressedButton = null

    makeAutoObservable(this)
  }

  setEmail(email: string) {
    this.email = email
  }

  setConfirmationCode(confirmationCode: string) {
    this.confirmationCode = confirmationCode
  }

  setIsCodeInputVisible(isCodeInputVisible: boolean) {
    this.isCodeInputVisible = isCodeInputVisible
  }

  setPressedButton(pressedButton: "signup" | "signin" | null) {
    this.pressedButton = pressedButton
  }
}
